<script>
  import { post } from "../utils/api";
  import { generateSign } from "../utils/signs";
  import { readTextFile } from "../utils/readFile";
  import { sendEmail } from "../utils/email";

  import { onMount } from "svelte";

  let email = "";
  let passwd1 = "";
  let passwd2 = "";
  let nombre = "";
  let apellido1 = "";
  let apellido2 = "";
  let institucion = "";
  let firma = "";
  let seleccionableRevisor = true;
  let aceptadosTerminos = false;

  let divErrorEmail;
  let divErrorPasswd1;
  let divErrorPasswd2;
  let divErrorNombre;
  let divErrorApellido1;
  let divErrorInstitucion;
  let divErrorFirma;
  let divErrorTerminos;

  let errorMsg = "";
  let okMsg = "";

  let letterCreateUser = "";

  onMount(async () => {
    letterCreateUser = await readTextFile("/letters/create-user.txt");
  });

  let register = async e => {
    const error =
      email === "" ||
      passwd1 === "" ||
      passwd2 === "" ||
      nombre === "" ||
      apellido1 === "" ||
      institucion === "" ||
      firma === "" ||
      !aceptadosTerminos ||
      divErrorEmail.classList.contains("has-error") ||
      divErrorPasswd1.classList.contains("has-error") ||
      divErrorPasswd2.classList.contains("has-error") ||
      divErrorNombre.classList.contains("has-error") ||
      divErrorApellido1.classList.contains("has-error") ||
      divErrorInstitucion.classList.contains("has-error") ||
      divErrorFirma.classList.contains("has-error") ||
      divErrorTerminos.classList.contains("has-error");
    if (!error) {
      e.preventDefault();
      if (passwd1 !== passwd2) {
        errorMsg = "Las contraseñas no coinciden.";
      } else {
        const response = await post(
          "RegistroUsuario",
          {
            email,
            password: passwd1,
            nombreUsuario: nombre,
            apellido1Usuario: apellido1,
            apellido2Usuario: apellido2,
            institucionUsuario: institucion,
            firmaUsuario: firma,
            seleccionableRevisor
          },
          "text"
        );
        if (response !== "") {
          errorMsg = response;
        } else {
          let body = letterCreateUser;
          body = body.replace(
            /%USUARIO%/g,
            nombre + " " + apellido1 + " " + apellido2
          );
          body = body.replace(/%EMAIL%/g, email);
          body = body.replace(/%PASSWORD%/g, passwd1);
          body = body.replace(/%INSTITUCION%/g, institucion);
          body = body.replace(/%FIRMA%/g, firma);
          sendEmail(email, "Registro de nuevo usuario", body);

          okMsg =
            "Usuario registrado con éxito. Vuelve a la pantalla de Login para acceder al sistema.";
        }
      }
    }
  };
</script>

<style>
  label.legal {
    text-align: justify;
    font-size: 12px;
  }
</style>

<div class="ie-panel">
  <a href="http://windows.microsoft.com/en-US/internet-explorer/">
    <img
      src="images/ie8-panel/warning_bar_0000_us.jpg"
      height="42"
      width="820"
      alt="You are using an outdated browser. For a faster, safer browsing
      experience, upgrade for free today." />
  </a>
</div>
<div class="preloader" id="loading">
  <div class="preloader-body">
    <div id="loading-center-object">
      <div class="object" id="object_four" />
      <div class="object" id="object_three" />
      <div class="object" id="object_two" />
      <div class="object" id="object_one" />
    </div>
  </div>
</div>
<div class="page">
  <section class="section section-layout-3-outer">
    <div class="section-layout-3">
      <div class="layout-2 section-layout-3-header">
        <div class="layout-2-inner">
          <div class="layout-2-item">
            <a class="link link-icon link-icon-left" href="login">
              <span class="icon mdi mdi-arrow-left" />
              <span>Volver</span>
            </a>
          </div>
          <div class="layout-2-item">
            <p class="text-1">
              <span>¿Ya tienes una cuenta?</span>
              <a class="text-accent" href="login">Acceder</a>
            </p>
          </div>
        </div>
      </div>
      <div class="section-layout-3-main">
        <div class="section-1 text-center">
          <div class="container">
            <div class="box-shadow-1">
              <a class="brand" href="/">
                <img
                  class="brand-logo-dark"
                  src="images/revista/logo.png"
                  alt="Logo" />
              </a>
              {#if okMsg !== ''}
                <div class="alert alert-success registerOk" role="alert">
                  {okMsg}
                  <a class="link link-icon link-icon-left" href="login">
                    <span class="icon mdi mdi-arrow-left" />
                    <span>Volver</span>
                  </a>
                </div>
              {:else}
                <p class="text-gray-900">
                  <span style="max-width: 400px">
                    Regístrate en nuestra plataforma para enviar tus artículos.
                  </span>
                </p>
                <div class="box-shadow-1-main">
                  <!-- RD Mailform-->
                  <form
                    class="rd-form rd-mailform"
                    action=""
                    method="post"
                    on:submit={e => register(e)}>

                    {#if errorMsg !== ''}
                      <div class="alert alert-danger" role="alert">
                        {errorMsg}
                      </div>
                    {/if}

                    <div class="form-wrap" bind:this={divErrorEmail}>
                      <input
                        class="form-input"
                        id="register-email"
                        type="email"
                        name="email"
                        placeholder="E-mail"
                        data-constraints="@Email @Required"
                        bind:value={email} />
                    </div>
                    <div class="form-wrap" bind:this={divErrorPasswd1}>
                      <input
                        class="form-input"
                        id="register-password1"
                        type="password"
                        name="password1"
                        placeholder="Contraseña"
                        data-constraints="@Required"
                        bind:value={passwd1} />
                    </div>
                    <div class="form-wrap" bind:this={divErrorPasswd2}>
                      <input
                        class="form-input"
                        id="register-password2"
                        type="password"
                        name="password2"
                        placeholder="Repite Contraseña"
                        data-constraints="@Required"
                        bind:value={passwd2} />
                    </div>
                    <div class="form-wrap" bind:this={divErrorNombre}>
                      <input
                        class="form-input"
                        id="register-name"
                        type="text"
                        name="nombre"
                        placeholder="Nombre"
                        data-constraints="@Required"
                        bind:value={nombre} />
                    </div>
                    <div class="form-wrap" bind:this={divErrorApellido1}>
                      <input
                        class="form-input"
                        id="register-lastname1"
                        type="text"
                        name="apellido1"
                        placeholder="Apellido 1"
                        data-constraints="@Required"
                        bind:value={apellido1} />
                    </div>
                    <div class="form-wrap">
                      <input
                        class="form-input"
                        id="register-lastname2"
                        type="text"
                        name="apellido2"
                        placeholder="Apellido 2"
                        bind:value={apellido2} />
                    </div>
                    <div class="form-wrap" bind:this={divErrorInstitucion}>
                      <input
                        class="form-input"
                        id="register-institution"
                        type="text"
                        name="institucion"
                        placeholder="Institución"
                        data-constraints="@Required"
                        bind:value={institucion} />
                    </div>
                    <div class="form-wrap" bind:this={divErrorFirma}>
                      <input
                        class="form-input"
                        id="register-sign"
                        type="text"
                        name="firma"
                        placeholder="Firma (científica)"
                        data-constraints="@Required"
                        bind:value={firma}
                        on:focus={() => {
                          if (nombre !== '' && apellido1 !== '' && firma === '') {
                            firma = generateSign(nombre, apellido1);
                          }
                        }} />
                    </div>
                    <div class="form-wrap">
                      <label class="form-check-label">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          bind:checked={seleccionableRevisor} />
                        Me gustaría ser propuesto como revisor en artículos
                        enviados por otros autores.
                      </label>
                    </div>
                    <div class="form-wrap">
                      <label class="form-check-label legal">
                        En cumplimiento de la Ley Orgánica 3/2018, de 5 de
                        diciembre, de Protección de Datos Personales y garantía
                        de los derechos digitales, y del Reglamento Europeo (UE)
                        2.016/679, del Parlamento Europeo y del Consejo, de 27
                        de abril de 2016, le informamos que los datos que nos
                        proporciona pasarán a formar parte de las bases de datos
                        titularidad del REAL E ILUSTRE COLEGIO OFICIAL DE
                        FARMACÉUTICOS DE SEVILLA cuya finalidad exclusiva es el
                        registro de artículos y su posterior publicación en la
                        Revista Española de Ciencias Farmacéuticas. El
                        interesado podrá ejercer los derechos de acceso,
                        rectificación, oposición, supresión, limitación del
                        tratamiento y portabilidad, expresamente reconocidos en
                        la citada L.O. 3/2018, mediante escrito, acompañado de
                        fotocopia del NIF, dirigido al REAL E ILUSTRE COLEGIO
                        OFICIAL DE FARMACÉUTICOS DE SEVILLA, C/ ALFONSO XII, Nº.
                        51 – 41001 SEVILLA o a través de los formularios que se
                        encuentran a su disposición en la dirección
                        anteriormente citada.
                      </label>
                    </div>
                    <div class="form-wrap" bind:this={divErrorTerminos}>
                      <label class="form-check-label">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          data-constraints="@Required"
                          bind:checked={aceptadosTerminos} />
                        He leído y acepto los términos legales detallados
                        <a href="/legal" target="_blank">aquí.</a>
                      </label>
                    </div>
                    <div class="form-wrap" disabled={true}>
                      <button
                        class="button button-block button-primary button-shadow"
                        type="submit">
                        Crear Cuenta
                      </button>
                    </div>
                  </form>
                </div>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<div class="snackbars" id="form-output-global" />
